import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Typography from "@material-ui/core/Typography";
import styled from "styled-components";
import ReactMarkdown from "react-markdown";
import { AnchorLink } from "gatsby-plugin-anchor-links";
import Modal from "react-bootstrap/Modal";

const StyledWrapper = styled.div`
  .heading,
  .subtext {
    letter-spacing: ${props => props.theme["zero"]};
    font-family: ${props => props.theme["primaryFont"]} !important;
  }

  .heading {
    color: ${props => props.theme["primaryColor"]} !important;
    font-size: ${props => props.theme["subHeadingSize"]} !important;
    font-weight: ${props => props.theme["headingBold"]} !important;
    line-height: ${props => props.theme["h2LineHeight"]} !important;
    text-transform: uppercase;

    @media (max-width: 600px) {
      font-size: ${props => props.theme["FooterLinkSize"]} !important;
      line-height: unset !important;
    }
  }

  .sub-heading-light {
    font-family: ${props => props.theme["primaryFont"]} !important;
    @media (max-width: 600px) {
      font-size: 14px !important;
    }
  }

  .subtext {
    font-size: 20px !important;
    font-weight: ${props => props.theme["textBold"]} !important;
    line-height: ${props => props.theme["subTextLineHeight"]} !important;

    @media (max-width: 600px) {
      font-size: 14px !important;
    }
  }

  .accordion-tab {
    background-color: ${props => props.theme["GreyBackgroundColor"]};
    border-bottom: 1px solid #c8c8c8 !important;
    box-shadow: none;
  }

  .award-img {
    max-width: 200px;
    @media (max-width: 600px) {
      max-width: 100px;
    }
  }

  .MuiIconButton-label {
    color: #464fd0;
    font-size: 42px;
  }

  .MuiAccordionSummary-root {
    padding: 0px !important;
  }

  .here-link {
    color: black;
    text-decoration: underline;
  }

  .react-desc a {
    text-decoration: underline;
    color: black;
  }

  .white-text {
    color: white;
  }

  .div-desc {
    font-size: 16px;
    font-weight: 400;
    color: white;
  }

  .Read-More {
    color: white;
    text-decoration: underline;
    cursor: pointer;
  }

  .modal-90w {
    width: 80%;
  }

  .row {
    display: flex;
  }

  .object-cover-top {
    object-fit: cover;
    object-position: top;
  }
`;

const useStyles = makeStyles(theme => ({
  root: {
    width: "100%",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "33.33%",
    flexShrink: 0,
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
  },
}));

export default function AwardAccordion({ accordion }) {
  const classes = useStyles();
  const [modalOpen, setModalOpen] = React.useState(false);
  const [modalData, setModalData] = React.useState("");
  const [modalHeading, setModalHeading] = React.useState("");
  const [modalImage, setModalImage] = React.useState("");
  const mainUrl = process.env.GATSBY_API_URL;
  return (
    <StyledWrapper>
      <div className={classes.root}>
        <h1 className="py-3">STORIES</h1>
        <div className="row">
          {accordion.length > 0 &&
            accordion.map((item, index) => (
              <div className="col-md-4 col-sm-12 pb-3">
                <div className="d-flex flex-column" style={{ height: "100%" }}>
                  {item.image && (
                    <img
                      src={mainUrl + item.image.url}
                      alt=""
                      className="object-cover-top"
                      height="240px"
                      width="100%"
                    />
                  )}

                  <div
                    className="p-3 d-flex flex-column flex-wrap justify-content-between"
                    style={{
                      background: item.color,
                      height: "calc(100% - 240px)",
                    }}
                  >
                    <h4 className="white-text">{item.heading}</h4>
                    <div className="div-desc">{item.brief}</div>
                    <div
                      onClick={() => {
                        setModalOpen(true);
                        setModalData(item.description);
                        setModalHeading(item.heading);
                        item.image && setModalImage(mainUrl + item.image.url);
                      }}
                      className="Read-More"
                    >
                      <h2>Read More</h2>
                    </div>
                  </div>
                </div>
              </div>
            ))}
        </div>
        <Modal show={modalOpen} onHide={() => setModalOpen(false)} size="xl">
          <Modal.Header closeButton>
            <Modal.Title>{modalHeading}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row">
              <div className="col-md-4">
                <img
                  src={modalImage}
                  className="img-fluid"
                  height="100%"
                  width="100%"
                />
              </div>
              <div className="col-md-8">
                <ReactMarkdown source={modalData} />
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </StyledWrapper>
  );
}
